import {
  SELL_INTELLIGENCE_CONFIGURATIONS,
  SELL_INTELLIGENCE_CONFIGURATIONS_LOADING,
  SELL_INTELLIGENCE_LOCALITY_SERVICES,
  SELL_INTELLIGENCE_INSIGHTS,
  SELL_INTELLIGENCE_INSIGHTS_LOADING,
  SELL_INTELLIGENCE_COMMENTS,
  SELL_INTELLIGENCE_COMMENTS_LOADING,
  SELL_INTELLIGENCE_ACKNOWLEDGEMENT,
  SELL_INTELLIGENCE_SAVE_CONFIG_SUCCESS,
  SELL_INTELLIGENCE_SAVE_COMMENT_SUCCESS,
  SELL_INTELLIGENCE_SUMMARY,
  SELL_INTELLIGENCE_SUMMARY_LOADING,
  SELL_INTELLIGENCE_RESET,
} from "../../utils/sellIntelligenceConstants";

const defaultState = {
  configurations: null,
  configurationsLoading: false,
  localityServices: {},
  insights: {},
  insightsLoading: false,
  comments: null,
  commentsLoading: false,
  acknowledgement: null,
  newConfigId: null,
  summary: null,
  summaryLoading: false,
};

export default function sellIntelligenceReducer(state = {}, action) {
  const currentState = state.sellIntelligence || defaultState;

  switch (action.type) {
    case SELL_INTELLIGENCE_CONFIGURATIONS:
      return {
        ...state,
        sellIntelligence: {
          ...currentState,
          configurations: action.payload,
        },
      };

    case SELL_INTELLIGENCE_CONFIGURATIONS_LOADING:
      return {
        ...state,
        sellIntelligence: {
          ...currentState,
          configurationsLoading: action.payload,
        },
      };

    case SELL_INTELLIGENCE_LOCALITY_SERVICES: {
      // Convert array of localities to map by localityUuid for easy lookup
      const servicesMap = {};
      if (Array.isArray(action.payload)) {
        action.payload.forEach((locality) => {
          const localityUuid = locality.localityUuid;
          if (localityUuid && locality.services) {
            servicesMap[localityUuid] = locality.services;
          }
        });
      }
      return {
        ...state,
        sellIntelligence: {
          ...currentState,
          localityServices: {
            ...currentState.localityServices,
            ...servicesMap,
          },
        },
      };
    }

    case SELL_INTELLIGENCE_INSIGHTS: {
      // Store insights by configId
      if (!action.payload) {
        return state;
      }
      const { configId, ...insightsData } = action.payload;
      return {
        ...state,
        sellIntelligence: {
          ...currentState,
          insights: {
            ...currentState.insights,
            [configId]: insightsData,
          },
        },
      };
    }

    case SELL_INTELLIGENCE_INSIGHTS_LOADING:
      return {
        ...state,
        sellIntelligence: {
          ...currentState,
          insightsLoading: action.payload,
        },
      };

    case SELL_INTELLIGENCE_COMMENTS:
      return {
        ...state,
        sellIntelligence: {
          ...currentState,
          comments: action.payload,
        },
      };

    case SELL_INTELLIGENCE_COMMENTS_LOADING:
      return {
        ...state,
        sellIntelligence: {
          ...currentState,
          commentsLoading: action.payload,
        },
      };

    case SELL_INTELLIGENCE_ACKNOWLEDGEMENT:
      return {
        ...state,
        sellIntelligence: {
          ...currentState,
          acknowledgement: action.payload,
        },
      };

    case SELL_INTELLIGENCE_SAVE_CONFIG_SUCCESS: {
      const configId = action.payload?.id || null;
      return {
        ...state,
        sellIntelligence: {
          ...currentState,
          newConfigId: configId,
        },
      };
    }

    case SELL_INTELLIGENCE_SAVE_COMMENT_SUCCESS:
      return state;

    case SELL_INTELLIGENCE_SUMMARY:
      return {
        ...state,
        sellIntelligence: {
          ...currentState,
          summary: action.payload,
        },
      };

    case SELL_INTELLIGENCE_SUMMARY_LOADING:
      return {
        ...state,
        sellIntelligence: {
          ...currentState,
          summaryLoading: action.payload,
        },
      };

    case SELL_INTELLIGENCE_RESET:
      return {
        ...state,
        sellIntelligence: {
          ...defaultState,
        },
      };
  }
}
